import { ModalRoot, ModalPage, ModalCard } from "@vkontakte/vkui";
import { useAction, useAtom } from "@reatom/npm-react";
import { openedModalAtom, toggleModal } from "@/core/reatom/state/modal/modal";
import { AuthModal } from "./modals/AuthModal/AuthModal";
import { Categories } from "../FilterModal/Сategories/Categories";
import { GarantyModal } from "../FilterModal/GarantyModal/GarantyModal";
import { FilterForm } from "../FilterModal/FilterForm/FilterForm";
import { SubCategories } from "../FilterModal/SubCategories/SubCategories";
import { DocumentsModal } from "./modals/DocumentsModal/DocumentsModal";
import { PaymentModal } from "./modals/PaymentModal/PaymentModal";
import { Status, StatusModal } from "./modals/StatusModal/StatusModal";
import { ChoosePaymentType } from "./modals/ChoosePaymentType/ChoosePaymentType";
import { Arbitrage } from "./modals/Arbitrage/Arbitrage";
import { Feedback } from "./modals/Feedback/Feedback";
import { AuthErrorAlert } from "./modals/AuthErrorAlert/AuthErrorAlert";

const Modals = () => {
  const [activeModal] = useAtom(openedModalAtom);
  const handleToggleModal = useAction(toggleModal);

  const closeModal = () => {
    handleToggleModal(null);
  };
  // activeModal
  // activeModal?.split(":")[0]
  return (
    <ModalRoot activeModal={activeModal?.split(":")[0]}>
      <ModalPage id="auth" onClose={closeModal} dynamicContentHeight>
        <AuthModal closeModal={closeModal} />
      </ModalPage>
      {/* Filters start*/}
      <ModalPage id="categories" onClose={closeModal} dynamicContentHeight>
        <Categories closeModal={closeModal} />
      </ModalPage>
      <ModalPage id="subCategories" onClose={closeModal} dynamicContentHeight>
        <SubCategories closeModal={closeModal} />
      </ModalPage>
      <ModalPage id="filterForm" onClose={closeModal} dynamicContentHeight>
        <FilterForm closeModal={closeModal} />
      </ModalPage>
      {/* Filters end */}
      <ModalCard id="garanty" onClose={closeModal} dismissButtonMode={"none"}>
        <GarantyModal closeModal={closeModal} />
      </ModalCard>
      <ModalCard id="documents" onClose={closeModal} dismissButtonMode={"none"}>
        <DocumentsModal closeModal={closeModal} />
      </ModalCard>
      <ModalCard id="payment" onClose={closeModal} dismissButtonMode={"none"}>
        <PaymentModal closeModal={closeModal} />
      </ModalCard>
      {/* <ModalCard
        id="payment-type"
        onClose={closeModal}
        dismissButtonMode={"none"}
      >
        <ChoosePaymentType
          closeModal={closeModal}
          orderId={activeModal?.split(":")[1]}
        />
      </ModalCard> */}
      <ModalPage id="status" onClose={closeModal} dynamicContentHeight>
        <StatusModal
          closeModal={closeModal}
          status={activeModal?.split(":")[1] as Status}
        />
      </ModalPage>
      <ModalPage id="arbitrage" onClose={closeModal} dynamicContentHeight>
        <Arbitrage closeModal={closeModal} />
      </ModalPage>
      <ModalPage id="feedback" onClose={closeModal} dynamicContentHeight>
        <Feedback
          closeModal={closeModal}
          isArbitrage={!!activeModal?.split(":")[1]}
        />
      </ModalPage>
      <ModalCard
        id="auth-error"
        onClose={closeModal}
        dismissButtonMode={"none"}
      >
        <AuthErrorAlert closeModal={closeModal} />
      </ModalCard>
    </ModalRoot>
  );
};

export default Modals;
